export type CountdownTone = 'normal' | 'warning' | 'critical' | 'expired';

export type BattleCountdown = {
  label: string;
  tone: CountdownTone;
  expired: boolean;
  refreshEveryMs: number | null;
};

const minute = 60_000;
const hour = 60 * minute;
const day = 24 * hour;

export function getBattleCountdown(
  votingEndsAt: string | null,
  now = Date.now(),
): BattleCountdown | null {
  if (!votingEndsAt) return null;
  const remaining = new Date(votingEndsAt).getTime() - now;
  if (!Number.isFinite(remaining) || remaining <= 0) {
    return {
      label: 'Finalizando batalla…',
      tone: 'expired',
      expired: true,
      refreshEveryMs: null,
    };
  }

  const days = Math.floor(remaining / day);
  const hours = Math.floor((remaining % day) / hour);
  const minutes = Math.floor((remaining % hour) / minute);
  const seconds = Math.floor((remaining % minute) / 1000);
  const label =
    days > 0
      ? `${unit(days, 'día', 'días')} · ${unit(hours, 'hora', 'horas')} · ${unit(minutes, 'minuto', 'minutos')}`
      : hours > 0
        ? `${unit(hours, 'hora', 'horas')} · ${unit(minutes, 'minuto', 'minutos')}`
        : `${unit(minutes, 'minuto', 'minutos')} · ${unit(seconds, 'segundo', 'segundos')}`;

  return {
    label,
    tone: remaining <= hour ? 'critical' : remaining <= day ? 'warning' : 'normal',
    expired: false,
    refreshEveryMs: remaining <= hour ? 1000 : minute,
  };
}

function unit(value: number, singular: string, plural: string) {
  return `${value} ${value === 1 ? singular : plural}`;
}

export function formatExactDeadline(value: string | null) {
  if (!value) return null;
  return new Intl.DateTimeFormat('es', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}
